function NorthKorea({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1814)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M16 0C11.1506 0 6.8054 2.15775 3.87122 5.56519H28.1288C25.1947 2.15775 20.8495 0 16 0Z" fill="#0052B4"/>
  <path d="M28.1288 26.4355H3.87122C6.8054 29.843 11.1506 32.0007 16 32.0007C20.8495 32.0007 25.1947 29.843 28.1288 26.4355Z" fill="#0052B4"/>
  <path d="M29.6516 7.65234H2.34838C0.859063 10.0827 0 12.941 0 16.0002C0 19.0593 0.859063 21.9177 2.34838 24.348H29.6516C31.1409 21.9177 32 19.0593 32 16.0002C32 12.941 31.1409 10.0827 29.6516 7.65234Z" fill="#D80027"/>
  <path d="M9.84351 22.1567C13.2436 22.1567 16 19.4004 16 16.0002C16 12.6001 13.2436 9.84375 9.84351 9.84375C6.44337 9.84375 3.68701 12.6001 3.68701 16.0002C3.68701 19.4004 6.44337 22.1567 9.84351 22.1567Z" fill="#F0F0F0"/>
  <path d="M9.84348 9.84375L11.2248 14.0951H15.7022L12.0786 16.7227L13.4707 20.9867L9.84348 18.3466L6.22173 20.9818L7.60835 16.7227L3.98804 14.0951H8.4621L9.84348 9.84375Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default NorthKorea;
